import { TGetRecommendedPayload, TGetRecommendedResponse } from 'store/product/types'
import { TFilterParams } from './types'
import { TProductsState } from '../ModalTieUpProduct/types'
import { ApiProductService } from 'store'
import useSWR from 'swr'
import { useMemo } from 'react'

export const defaultParams: TFilterParams = {
   date_start: '',
   date_end: '',
   query: '',
   category: undefined,
   sortBy: 'createdAt',
   order: -1
   // page: 0
}

export const useGetSimilars = (params: TGetRecommendedPayload) => {
   const { data: similarData, isLoading: similarLoading } = useSWR(
      params._id ? ['getSimilarProducts', params] : null,
      ([, getParams]) => ApiProductService.getRecommended(getParams),

      { revalidateOnFocus: false }
   )
   return { similarData, similarLoading }
}

export const useGetSimilarData = (
   products: TProductsState,
   similarData?: TGetRecommendedResponse
) => {
   const initialSimilarData = products[0]?.product

   const processedData = useMemo(() => {
      return similarData?.data?.length
         ? similarData?.data?.find((el) => el._id === initialSimilarData?._id)
            ? similarData?.data
            : [...similarData?.data, initialSimilarData]
         : [initialSimilarData]
   }, [similarData])
   return { processedData }
}
